import { Loader } from '@seen/react'
import { type JSX, lazy, Suspense } from 'react'

// The onboarding questionnaire is a ~2,500-line inline FHIR Questionnaire
// literal, reached only by typing /onboarding. App.tsx's <Outlet /> already
// supplies Suspense + an ErrorBoundary; the local Suspense keeps this safe if
// it is ever mounted somewhere without one.
const OnboardingPageImpl = lazy(() =>
  import('#src/pages/OnboardingPageImpl.tsx').then((m) => ({
    default: m.OnboardingPageImpl,
  }))
)

export function OnboardingPage(): JSX.Element {
  return (
    <Suspense fallback={<Loader />}>
      <OnboardingPageImpl />
    </Suspense>
  )
}
